
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/privacy-old",
      function () {
        return require("private-next-pages/legal/privacy-old.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/privacy-old"])
      });
    }
  